import { useEffect } from 'react';
import useRequest from '@/websdk/utils/request';

export default (function (id) {
  const { exec, isRequestSuccessed, rst } = useRequest({
    name: 'DELETE_FIRST_INSPECTION_INFERIORS',
    url: ``,
    method: 'DELETE',
  });
  useEffect(() => {
    if (id) {
      exec({
        url: `/api/inspection/first/inferiors/${id}`
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return [isRequestSuccessed, rst];
});